<div *appIsGranted="['OTHERS', 'OTHERS_SUPPLIER_CONTROL', 'READ']">
  <div class="card overflow-auto">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <h4>Controle de fornecedores</h4>
        </div>

        <div class="col-md-2">
          <button
            *appIsGranted="['OTHERS', 'OTHERS_SUPPLIER_CONTROL', 'CREATE']"
            class="btn btn-primary"
            (click)="openModal(modalCreateItem)"
          >
            Adicionar
          </button>
        </div>
      </div>
      <div></div>
    </div>
    <div class="card-body">
      <div class="card align-items-center" *ngIf="circularProgressiveWait">
        <div card="card-body">
          <div class="spinner-border text-primary m-1" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
      <!-- <pre [innerHTML]="tableSupplierHTMLString"></pre> -->
      <p id="table_supplier"></p>
    </div>
  </div>
</div>

<div class="card overflow-auto">
  <div class="card-header"><h6>Lista dos itens</h6></div>
  <div class="card-body">
    <table class="table table-fit table-bordered table-hover">
      <thead class="table-primary">
        <tr>
          <th class="text-center" scope="col">Id</th>
          <th class="text-center" scope="col">Fornecedor</th>
          <th class="text-center" scope="col">Agrupador</th>
          <th class="text-center" scope="col">Grupo</th>
          <th class="text-center" scope="col">Modelo</th>
          <th class="text-center" scope="col">Status</th>
          <th class="text-center" scope="col">Exemplo Serial</th>
          <th class="text-center" scope="col">Ação</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of supplierItem; let i = index">
          <td class="text-center" scope="row">{{ item.id }}</td>
          <td class="text-center" scope="row">{{ item.supplierName }}</td>
          <td class="text-center" scope="row">{{ item.grouping }}</td>
          <td class="text-center" scope="row">{{ item.group }}</td>
          <td class="text-center" scope="row">{{ item.itemModel }}</td>
          <td class="text-center" scope="row">{{ item.status }}</td>
          <td class="text-center" scope="row">
            {{ templateSerial(item) }}
          </td>

          <td class="text-center" scope="row">
            <button
              *appIsGranted="['OTHERS', 'OTHERS_SUPPLIER_CONTROL', 'UPDATE']"
              class="btn btn-primary"
              (click)="updateModal(item, modalUpdateItem)"
            >
              Editar
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Dialog Insert Supplier -->
<ng-template #modalCreateItem let-modal>
  <div class="modal-header">
    <h5 class="modal-title mt-0">Inserir novo item</h5>
    <button
      type="button"
      class="btn btn-close"
      (click)="modal.dismiss('Cross click')"
      aria-hidden="true"
    ></button>
  </div>
  <div class="modal-body">
    <form id="formInsertNewItem" data-toggle="validator" role="form">
      <div class="row mb-3">
        <label>Selecione um fornecedor</label>
        <div class="col-8">
          <div class="form-grouping">
            <ng-select
              id="supplierSelect"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="newSupplierItem.supplierName"
            >
              <ng-option
                *ngFor="
                  let supplierItemName of tableSupplierItemHeader.supplier
                "
                [value]="supplierItemName"
              >
                {{ supplierItemName }}
              </ng-option>
            </ng-select>
          </div>
        </div>
        <div class="col-4">
          <button
            class="btn btn-sm btn-primary"
            (click)="openModalSmall(modalInsertNewSupplier)"
          >
            Novo fornecedor
          </button>
        </div>
      </div>
      <div class="row mb-3">
        <label>Selecione um agrupador</label>
        <div class="col-8">
          <div class="form-grouping">
            <ng-select
              id="groupingSelect"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="newSupplierItem.grouping"
              (ngModelChange)="filterGroupSelect(newSupplierItem.grouping)"
            >
              <ng-option
                *ngFor="let groupingItemName of tableGroupingList"
                [value]="groupingItemName"
              >
                {{ groupingItemName }}
              </ng-option>
            </ng-select>
          </div>
        </div>
        <div class="col-md-4">
          <button
            class="btn btn-sm btn-primary"
            (click)="openModalSmall(modalInsertNewGroup)"
          >
            Novo agrupador ou grupo
          </button>
        </div>
      </div>
      <div class="row mb-3">
        <label>Selecione um grupo</label>
        <div class="col-8">
          <div class="form-grouping">
            <div class="form-floating">
              <ng-select
                id="supplierSelect"
                [(ngModel)]="newSupplierItem.group"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="filterModelByGroup(newSupplierItem)"
              >
                <div *ngFor="let groupItemName of groupSelect">
                  <ng-option [value]="groupItemName">
                    {{ groupItemName }}
                  </ng-option>
                </div>
              </ng-select>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <label>Status</label>
        <div class="col-8">
          <div class="form-grouping">
            <div class="form-floating">
              <ng-select
                id="itemStatus"
                [(ngModel)]="newSupplierItem.status"
                [ngModelOptions]="{ standalone: true }"
              >
                <ng-option value="Catálogo"> Catálogo </ng-option>
                <ng-option value="Em Homologação"> Em Homologação </ng-option>
                <ng-option value="Homologado"> Homologado </ng-option>
                <ng-option value="Bloqueado"> Bloqueado </ng-option>
                <ng-option value="Obsoleto"> Obsoleto </ng-option>
              </ng-select>
            </div>
          </div>
        </div>
      </div>
      <div class="card m-3">
        <label class="control-label"
          >Outros modelos existentes desse grupo</label
        >
        <b>{{ filterModel }}</b>
      </div>
      <div class="form-grouping">
        <label for="formModelName" class="control-label">Modelo</label>
        <input
          id="formModelName"
          class="form-control"
          placeholder="Digite o modelo do item"
          type="text"
          name="itemModelName"
          [(ngModel)]="newSupplierItem.itemModel"
          (change)="verifyExistItemModel(newSupplierItem.itemModel)"
          required
        />
      </div>
      <button
        class="btn btn-sm btn-success align-items-end m-3"
        type="submit"
        [disabled]="
          newSupplierItem.itemModel == '' ||
          newSupplierItem.supplierName == '' ||
          newSupplierItem.status == '' ||
          newSupplierItem.grouping == '' ||
          newSupplierItem.group == '' ||
          filterModelBlock
        "
        (click)="insertNewSupplierItem(); modal.dismiss('Cross click')"
      >
        Salvar
      </button>
      <label
        class="text-danger"
        *ngIf="
          newSupplierItem.itemModel == '' ||
          newSupplierItem.supplierName == '' ||
          newSupplierItem.status == '' ||
          newSupplierItem.grouping == '' ||
          newSupplierItem.group == ''
        "
        >Preencha todos os campos!</label
      >
      <label class="ms-2 text-danger" *ngIf="filterModelBlock"
        >Númeração do modelo já existe</label
      >
    </form>
  </div>
</ng-template>
<!--Fim Dialog-->

<!-- Dialog Insert Supplier -->
<ng-template #modalInsertNewSupplier let-modal>
  <div style="background-color: rgba(209, 208, 208, 0.795)">
    <div class="modal-header">
      <h5 class="modal-title mt-0">Inserir novo fornecedor</h5>
      <button
        type="button"
        class="btn btn-close"
        (click)="modal.dismiss('Cross click')"
        aria-hidden="true"
      ></button>
    </div>
    <div class="modal-body">
      <form id="formNewGroup" data-toggle="validator" role="form">
        <div class="mb-3">
          <div class="form-grouping">
            <label for="newSupplier" class="col-form-label"
              >Inserir um Fornecedor</label
            >
            <input
              class="form-control mb-3"
              type="text"
              id="newSupplier"
              #newSupplier
            />
            <div>
              <button
                type="submit"
                [disabled]="
                  newSupplier.value == '' || newSupplier.value == null
                "
                (click)="
                  insertSupplierLocal(newSupplier.value);
                  modal.dismiss('Cross click')
                "
                class="btn btn-success"
              >
                Adicionar
              </button>
              <label
                class="text-danger"
                *ngIf="newSupplier.value == '' || newSupplier.value == null"
                >Preencha todos os campos!</label
              >
            </div>
          </div>
          <!-- end row -->
        </div>
      </form>
    </div>
  </div>
</ng-template>
<!--Fim Dialog-->

<!-- Dialog Insert Group -->
<ng-template #modalInsertNewGroup let-modal>
  <div style="background-color: rgba(209, 208, 208, 0.795)">
    <div class="modal-header">
      <h5 class="modal-title mt-0">Inserir novo Agrupador ou Grupo</h5>

      <button
        type="button"
        class="btn btn-close"
        (click)="modal.dismiss('Cross click')"
        aria-hidden="true"
      ></button>
    </div>
    <div class="modal-body">
      <h6>
        * para criar apenas um grupo, o grupo deve ser preenchido com o nome já
        existente
      </h6>
      <div class="mb-3">
        <form id="formNewGrouping" data-toggle="validator" role="form">
          <div class="form-grouping">
            <label for="newGrouping" class="col-form-label"
              >Inserir um Agrupador</label
            >
            <input
              class="form-control mb-3"
              type="text"
              id="newGrouping"
              name="newGrouping"
              required
              #newGrouping
            />
          </div>
          <div class="mb-3">
            <div class="form-grouping">
              <label for="newGroup" class="col-form-label"
                >Inserir um grupo</label
              >
              <input
                class="form-control mb-3"
                type="text"
                id="newGroup"
                name="newGroup"
                #newGroup
                required
              />
            </div>
          </div>
          <div></div>
          <div>
            <button
              type="submit"
              [disabled]="newGrouping.value == '' || newGroup.value == ''"
              (click)="
                insertGroupLocal(newGrouping.value, newGroup.value);
                modal.dismiss('Cross click')
              "
              class="btn btn-success"
            >
              Adicionar
            </button>
            <label
              class="text-danger"
              *ngIf="newGrouping.value == '' || newGroup.value == ''"
              >Preencha todos os campos!</label
            >
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-template>
<!--Fim Dialog-->

<!-- Dialog Update Supplier -->
<ng-template #modalUpdateItem let-modal>
  <div class="modal-header">
    <h5 class="modal-title mt-0">Atualizar um item</h5>
    <button
      type="button"
      class="btn btn-close"
      (click)="modal.dismiss('Cross click')"
      aria-hidden="true"
    ></button>
  </div>
  <div class="modal-body">
    <form id="formInsertNewItem" data-toggle="validator" role="form">
      <div class="row mb-3">
        <label>Selecione um fornecedor</label>
        <div class="col-8">
          <div class="form-grouping">
            <ng-select
              id="supplierSelect"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="updateSupplierItem.supplierName"
            >
              <ng-option
                *ngFor="
                  let supplierItemName of tableSupplierItemHeader.supplier
                "
                [value]="supplierItemName"
              >
                {{ supplierItemName }}
              </ng-option>
            </ng-select>
          </div>
        </div>
        <div class="col-4">
          <button
            class="btn btn-sm btn-primary"
            (click)="openModalSmall(modalInsertNewSupplier)"
          >
            Novo fornecedor
          </button>
        </div>
      </div>
      <div class="row mb-3">
        <label>Selecione um agrupador</label>
        <div class="col-8">
          <div class="form-grouping">
            <ng-select
              id="groupingSelect"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="updateSupplierItem.grouping"
              (ngModelChange)="filterGroupSelect(updateSupplierItem.grouping)"
            >
              <ng-option
                *ngFor="let groupingItemName of tableGroupingList"
                [value]="groupingItemName"
              >
                {{ groupingItemName }}
              </ng-option>
            </ng-select>
          </div>
        </div>
        <div class="col-md-4">
          <button
            class="btn btn-sm btn-primary"
            (click)="openModalSmall(modalInsertNewGroup)"
          >
            Novo Agrupador ou Grupo
          </button>
        </div>
      </div>
      <div class="row mb-3">
        <label>Selecione um Grupo</label>
        <div class="col-8">
          <div class="form-grouping">
            <div class="form-floating">
              <ng-select
                id="supplierSelect"
                [(ngModel)]="updateSupplierItem.group"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="filterModelByGroup(updateSupplierItem)"
              >
                <div *ngFor="let groupItemName of groupSelect">
                  <ng-option [value]="groupItemName">
                    {{ groupItemName }}
                  </ng-option>
                </div>
              </ng-select>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <label>Status</label>
        <div class="col-8">
          <div class="form-grouping">
            <div class="form-floating">
              <ng-select
                id="itemStatus"
                [(ngModel)]="updateSupplierItem.status"
                [ngModelOptions]="{ standalone: true }"
              >
                <ng-option value="Catálogo"> Catálogo </ng-option>
                <ng-option value="Em Homologação"> Em Homologação </ng-option>
                <ng-option value="Homologado"> Homologado </ng-option>
                <ng-option value="Bloqueado"> Bloqueado </ng-option>
                <ng-option value="Obsoleto"> Obsoleto </ng-option>
              </ng-select>
            </div>
          </div>
        </div>
      </div>

      <div class="card m-3">
        <label class="control-label"
          >Outros modelos existentes desse grupo</label
        >
        <b>{{ filterModel }}</b>
      </div>
      <div class="form-grouping">
        <label for="formModelName" class="control-label">Modelo</label>
        <input
          id="formModelName"
          class="form-control"
          placeholder="Digite o modelo do item"
          type="text"
          name="itemModelName"
          [(ngModel)]="updateSupplierItem.itemModel"
          (ngModelChange)="verifyExistItemModel(updateSupplierItem.itemModel)"
          required
        />
      </div>
      <button
        class="btn btn-sm btn-success align-items-end m-3"
        type="submit"
        [disabled]="
          updateSupplierItem.itemModel == '' ||
          updateSupplierItem.supplierName == '' ||
          updateSupplierItem.status == '' ||
          updateSupplierItem.grouping == '' ||
          updateSupplierItem.group == '' ||
          filterModelBlock
        "
        (click)="
          updateItem(updateSupplierItem, updateSupplierItem.id);
          modal.dismiss('Cross click')
        "
      >
        Salvar
      </button>
      <!-- <ng-container *ngIf="exludeItemConfirm"> -->
      <button
        class="btn btn-sm btn-danger align-items-end m-3"
        type="submit"
        [disabled]="
          updateSupplierItem.itemModel == '' ||
          updateSupplierItem.supplierName == '' ||
          updateSupplierItem.status == '' ||
          updateSupplierItem.grouping == '' ||
          updateSupplierItem.group == '' ||
          !allowExclude
        "
        (click)="
          excludeItem(updateSupplierItem.id); modal.dismiss('Cross click')
        "
      >
        Excluir
      </button>
      <input
        type="checkbox"
        id="allowExclude"
        [(ngModel)]="allowExclude"
        name="allowExclude"
      />
      <label class="ms-3"> Liberar Exclusão</label>
      <label
        class="ms-3"
        class="text-danger"
        *ngIf="
          updateSupplierItem.itemModel == '' ||
          updateSupplierItem.supplierName == '' ||
          updateSupplierItem.status == '' ||
          updateSupplierItem.grouping == '' ||
          updateSupplierItem.group == ''
        "
        >Preencha todos os campos!</label
      >
      <label class="ms-2 text-danger" *ngIf="filterModelBlock"
        >Númeração do modelo já existe</label
      >
    </form>
  </div>
</ng-template>
<!--Fim Dialog-->
